import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemText,
    Chip
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function AboutSection({ aboutInfo }) {
    if (!aboutInfo) {
        return (
            <Box sx={{ textAlign: 'left' }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 500 }}>
                    About
                </Typography>
                <Typography color="text.secondary">
                    Loading application information...
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 500 }}>
                About Fusion Inscribe
            </Typography>

            <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <InfoIcon color="primary" fontSize="large" />
                    <Box>
                        <Typography variant="h6">
                            Fusion Inscribe
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Document Management Solution
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: 'flex', gap: 4, mb: 2 }}>
                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            Version
                        </Typography>
                        <Typography variant="h6">
                            {aboutInfo.version || 'Unknown'}
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {aboutInfo.packages && Object.keys(aboutInfo.packages).length > 0 && (
                <>
                    <Typography variant="h6" gutterBottom sx={{ mt: 4, mb: 2 }}>
                        Dependencies
                    </Typography>

                    <Paper variant="outlined">
                        <List dense>
                            {Object.entries(aboutInfo.packages).map(([name, version], index) => (
                                <React.Fragment key={name}>
                                    {index > 0 && <Divider />}
                                    <ListItem>
                                        <ListItemText
                                            primary={name}
                                            primaryTypographyProps={{
                                                fontFamily: 'monospace',
                                                fontSize: '0.875rem'
                                            }}
                                        />
                                        <Chip
                                            label={version}
                                            size="small"
                                            variant="outlined"
                                            sx={{ fontFamily: 'monospace' }}
                                        />
                                    </ListItem>
                                </React.Fragment>
                            ))}
                        </List>
                    </Paper>
                </>
            )}
        </Box>
    );
}

export default AboutSection;
